import { useEffect } from 'react';

import type { EditMode } from '@pages/Integrations/IntegrationsList/components/Edit1CIntegrationModal/types';

interface UseEdit1CIntegrationModalEffectsProps {
  isOpen: boolean;
  integrationId: number | null;
  initialMode: EditMode;
  handleReset: () => void;
  handleFetchIntegration: () => Promise<void>;
  handleModeChange: (mode: EditMode) => void;
}

export const useEdit1CIntegrationModalEffects = (
  props: UseEdit1CIntegrationModalEffectsProps
) => {
  const {
    isOpen,
    integrationId,
    initialMode,
    handleReset,
    handleFetchIntegration,
    handleModeChange,
  } = props;

  useEffect(() => {
    if (!isOpen) {
      handleReset();
    }
  }, [handleReset, isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    if (!integrationId) return;

    handleModeChange(initialMode);

    void handleFetchIntegration();
  }, [
    handleFetchIntegration,
    handleModeChange,
    initialMode,
    integrationId,
    isOpen,
  ]);
};
